<div class="section position-relative">
    <div class="section-top">
        <h3 class="section-title">Programări Sloturi Borderou</h3>
        <div clasas="section-top-actions">
            <button type="button" class="btn btn-sm btn-info pull-right ms-1" (click)="rerenderDT(false)">
                <i class="fa-solid fa-arrows-rotate"></i>
            </button>
            <button type="button"
                *ngIf="permissionsService.hasPermission('auth-module.ghiseu-settings.programari-ultima-ora.add')"
                class="btn btn-sm btn-primary pull-right ms-1" (click)="openAddDialog()">
                <i class="fa-solid fa-plus"></i>
                Adaugă
            </button>
        </div>
    </div>

    <!-- Card Filtre -->
    <div class="card-container p-2" *ngIf="showCard">
        <form [formGroup]="searchParamsForm">
            <div class="row">
                <!-- Modul -->
                <div class="col-md-4">
                    <mat-form-field>
                        <mat-label>Modul</mat-label>
                        <mat-select formControlName="id_modul" (openedChange)="onModuleSelectClosed()">
                            <mat-form-field class="px-2 w-100 sticky-input">
                                <input matInput [formControl]="moduleControl" (keydown)="$event.stopPropagation()"
                                    (click)="$event.stopPropagation()" placeholder="Căutare..." />
                            </mat-form-field>

                            <mat-option *ngIf="filteredModule.length === 0" disabled>
                                <span>Nu s-au găsit rezultate</span>
                            </mat-option>

                            <mat-option [value]="-1">-- Toate --</mat-option>
                            <mat-option *ngFor="let modul of filteredModule" [value]="modul.id">
                                {{ modul.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Locație -->
                <div class="col-md-4">
                    <mat-form-field>
                        <mat-label>Locație</mat-label>
                        <mat-select formControlName="id_locatie" (openedChange)="onLocatiiSelectClosed()">
                            <mat-form-field class="px-2 w-100 sticky-input">
                                <input matInput [formControl]="locatiiControl" (keydown)="$event.stopPropagation()"
                                    (click)="$event.stopPropagation()" placeholder="Căutare..." />
                            </mat-form-field>

                            <mat-option *ngIf="filteredLocatii.length === 0" disabled>
                                <span>Nu s-au găsit rezultate</span>
                            </mat-option>

                            <mat-option [value]="-1">-- Toate --</mat-option>
                            <mat-option *ngFor="let locatie of filteredLocatii" [value]="locatie.id">
                                {{ locatie.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Serviciu -->
                <div class="col-md-4">
                    <mat-form-field>
                        <mat-label>Serviciu</mat-label>
                        <mat-select formControlName="id_serviciu" (openedChange)="onServiciiSelectClosed()">
                            <mat-form-field class="px-2 w-100 sticky-input">
                                <input matInput [formControl]="serviciiControl" (keydown)="$event.stopPropagation()"
                                    (click)="$event.stopPropagation()" placeholder="Căutare..." />
                            </mat-form-field>

                            <mat-option *ngIf="filteredServicii.length === 0" disabled>
                                <span>Nu s-au găsit rezultate</span>
                            </mat-option>

                            <mat-option [value]="-1">-- Toate --</mat-option>
                            <mat-option *ngFor="let serviciu of filteredServicii" [value]="serviciu.id">
                                {{ serviciu.web_name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </form>

        <div class="row w-100">
            <div class="col d-flex justify-content-start">
                <button (click)="toggleCard()" type="button" class="btn btn-sm btn-warning closeBtn">Închide</button>
            </div>
            <div class="col buttons-submit">
                <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                    Resetează
                </button>
                <button (click)="applyFilters()" type="submit" class="btn btn-sm btn-primary ms-2">
                    Aplică
                </button>
            </div>
        </div>

        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
            <div class="spinner position-absolute top-50 start-50 translate-middle">
                <mat-spinner></mat-spinner>
                <h3 class="mt-2">
                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                </h3>
            </div>
        </div>
    </div>

    <!-- Buton Filtre -->
    <div class="col-sm-12 ps-3">
        <button type="button" class="btn btn-sm btn-default" (click)="toggleCard()" [class.active]="showCard">
            <i class="fa-solid fa-filter"></i> Filtre
        </button>
    </div>

    <div class="table-container position-relative">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover w-100"></table>
    </div>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>
